import { NotificationTypes } from '@chegg-ui/notification-banner';
import { setIsToastOpen } from "../../slices/errorModal";
import { changeRoute } from "../../slices/router";
import { getTexts } from "../../../utils/texts";
var _getTexts = getTexts(),
  _getTexts$errorMessag = _getTexts.errorMessages.sessionBlocked,
  bannerTitle = _getTexts$errorMessag.bannerTitle,
  bannerMessage = _getTexts$errorMessag.bannerMessage,
  notificationSent = _getTexts.informationMessages.notificationSent;
export function handleToastMessage(dispatch, errorTypeOrRoute) {
  switch (errorTypeOrRoute) {
    case 'sent_session_expired':
      {
        dispatch(changeRoute('timeout'));
        break;
      }
    case 'qr_session_expired':
      {
        dispatch(changeRoute('timeout'));
        break;
      }
    case 'blocked':
      {
        dispatch(setIsToastOpen({
          isOpen: true,
          title: bannerTitle,
          message: bannerMessage
        }));
        break;
      }
    case 'push_sent':
      {
        dispatch(setIsToastOpen({
          isOpen: true,
          type: NotificationTypes.Information,
          message: notificationSent.bannerMessageOnRetry,
          disappearAfterMs: 5000
        }));
        break;
      }
  }
}
export function isValidRoute(route) {
  return ['/', 'factor_selector', 'mfa-by-email', 'qr', 'push_sent', 'error', 'general_error', 'os_push_declined'].includes(route);
}